import { Link } from 'react-router-dom';

import { Button } from '@components/ui/button';

export default function HomePage() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center space-y-6 p-4">
      <div className="text-center">
        <h1 className="text-h2 mb-4">📱 X-Web Mobile</h1>
        <p className="text-muted-foreground mb-8">
          Welcome to the mobile webview dashboard
        </p>
      </div>

      <div className="flex flex-col space-y-4">
        <Button asChild>
          <Link to="/about">Learn About This App</Link>
        </Button>

        <Button variant="secondary">Webview Home</Button>
      </div>
    </div>
  );
}
